<template>
    <transition name="fade">
        <div class="ui-nf-loading" v-show="showLoading">
            <div class="loading-wrapper">
                <div class="loading-img">
                    <loading></loading>
                </div>
                <p class="txt">{{ text }}</p>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
  name: 'nfLoading',
  props: {
    text: {
      type: String,
      default: '加载中...'
    },
    showLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.ui-nf-loading {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0);
}
.loading-wrapper {
  width: 2rem;
  height: 2.2rem;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 0.1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 0.1rem 0;
}
.loading-img {
  width: 1.5rem;
  height: 1.5rem;
}
.txt {
  width: 100%;
  text-align: center;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.24rem;
  color: #fcfcfc;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
</style>


